<app-top-categories-navbar *ngIf="!isAccountSubsidiary" class="top-navigation"
                           [categories]="homeHeaderCategories$ | async"
></app-top-categories-navbar>

<ng-container *ngIf="isClient">
  <noscript>
    <ng-container *ngFor="let category of homeHeaderCategories$ | async">
      <a [href]="hostUrl+'/c/' + category?.slug">{{category?.name}}</a>
      <ng-container *ngFor="let subcategories of category.children">
        <a [href]="hostUrl+'/c/' + subcategories?.slug">
          {{ subcategories?.name }}
        </a>
        <ng-container *ngFor="let subNestedCategories of subcategories?.children">
          <a [href]="hostUrl+'/c/' + subNestedCategories?.slug">
            {{ subNestedCategories?.name }}
          </a>
        </ng-container>
      </ng-container>
    </ng-container>
  </noscript>
</ng-container>
